module.exports = __webpack_public_path__ + "img/ic_dashboard.88bd8a74.svg";